<template>
  <div class="flex flex-col w-64 bg-white flex-no-shrink flex-no-grow border-solid border-r border-grey-lightest">
    <div v-if="role !== 'specialistDoctor'" class="flex flex-col flex-no-shrink p-2 bg-grey-extralight">
      <input @click="openSearch($event)" placeholder="Search Patient" type="text" class="text-sm border border-grey-lightest rounded-m mb-1" style="min-height: 40px; padding: 4px 8px 4px 8px;"/> 
    </div>
    <div class="flex relative flex-col pt-1 flex-no-shrink flex-no-grow border-solid border-t border-grey-lightest">
      <div class="flex flex-row h-12 text-xs items-center">
          <div @click="setActiveSection('connected')" v-bind:class="[activeSection === 'connected' ? 'font-semibold' : 'hover:text-blue hover:font-semibold']" class="w-1/3 text-grey-darkest text-center cursor-pointer">Connected</div>
          <div @click="setActiveSection('consults')" v-bind:class="[activeSection === 'consults' ? 'font-semibold' : 'hover:text-blue hover:font-semibold']" class="w-1/3 text-grey-darkest text-center cursor-pointer">Completed</div>
      </div>
      <div class="flex flex-row h-1 bg-grey-lightest">
          <div class="w-1/3" v-bind:class="[activeSection === 'connected' ? 'bg-blue' : '']"></div>
          <div class="w-1/3" v-bind:class="[activeSection === 'consults' ? 'bg-blue' : '']"> </div>
      </div>
      <div v-if="activeOfflineConsults.length>0" class="absolute text-xs bg-green text-white flex flex-row justify-center items-center" style="top: 0rem; left: 1.5rem; width: 2rem; height: 1rem; border-bottom-left-radius: 50%; border-bottom-right-radius: 50%;"> 
        {{activeOfflineConsults.length}} 
      </div>
      <div v-if="pastOfflineConsults.length>0" class="absolute text-xs bg-grey-lighter text-white flex flex-row justify-center items-center" style="top: 0rem; left: 7rem; width: 2rem; height: 1rem; border-bottom-left-radius: 50%; border-bottom-right-radius: 50%;">
        {{totalPastConsults}}
      </div>  
    </div>
    <!--Connected Components -->
    <div class = "overflow-auto" v-if="activeSection === 'connected'">
      <div v-if="activeOfflineConsults.length === 0">
        <span class="text-sm flex justify-center my-4">No Active Offline Consultations</span>
      </div>
      <active-consultations v-else/>
    </div>
    <!--Past Consult Components -->
    <div class = "overflow-auto" v-if="activeSection === 'consults'" >
      <div v-if="pastOfflineConsults.length === 0">
        <span class="text-sm flex justify-center my-4">No past offline consultations</span>
      </div>
      <past-consultations v-else/>
    </div>
    <UnsavedChangesModal v-if="showSaveReminder" @close='closeModal'/>
    <SearchModal v-if="showSearchModal" @closeSearchModal="closeSearchModal" @addNewCustomer="addNewCustomer"/>
  </div>
</template>

<script>

import {mapState, mapGetters} from 'vuex'
import ActiveConsultations from '@/components/OfflineConsultations/ActiveOfflineConsultations'
import PastConsultations from '@/components/OfflineConsultations/PastOfflineConsultations.vue'
import UnsavedChangesModal from '@/components/common/modals/UnsavedChanges'
import SearchModal from '@/components/OfflineConsultations/SearchModal'
export default {
  components: {
    ActiveConsultations,
    PastConsultations,
    SearchModal,
    UnsavedChangesModal
  },
  data () {
    return {
      search: {email: '', first_name: '', last_name: '', mobile_number: '', employee_id: ''},
      patients: [],
      selectedTab: 'connected',
      showSaveReminder: false,
      query: '',
      showSearchModal: false
    }
  },
  computed: {
    ...mapGetters({
      searchResult: 'offlineConsultation/searchResult',
      activeSection: 'configuration/getActiveSection',
      role: 'configuration/getRole'
    }),
    ...mapState({
      activeOfflineConsults: state => state.offlineConsultation.activeOfflineConsults,
      pastOfflineConsults: state => state.pastOfflineConsultation.pastOfflineConsults,
      totalPastConsults: state => state.pastOfflineConsultation.totalPastConsults,
      editTextField: state => state.textField.inEdit
    })
  },
  methods: {
    openSearch: function (e) {
      this.showSearchModal = true
      e.target.blur()
    },
    closeSearchModal: function () {
      this.showSearchModal = false
    },
    addNewCustomer: function (customer) {
      this.$store.dispatch('offlineConsultation/addNewCustomer', customer)
      this.$emit('tabChange', 'consultation-summary')
    },
    setActiveSection: function (section) {
      if (this.editTextField) {
        this.showSaveReminder = true
        return
      }
      this.selectedTab = section
      this.$store.dispatch('configuration/setOfflineActiveSection', section)
    },
    closeModal: function (params) {
      this.showSaveReminder = false
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/OfflineConsultations/LeftPaneOffline.vue